import styled, { css } from "styled-components";
import { HashLink as Link } from "react-router-hash-link";
import Container from "../../atoms/Container/Container.styled";
import { withDisplayHeading } from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const ClosingSection = styled.section(
  ({ theme }) => css`
    background: ${theme.colors.brand.deep};
    color: ${theme.colors.white};
    overflow: hidden;
    padding: 76px 0 0;
    position: relative;

    &::before {
      background: ${theme.gradients.brand};
      content: "";
      height: 3px;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    @media ${deviceMax.phoneMax} {
      padding-top: 54px;
    }
  `
);

export const ClosingWrapper = styled(Container)``;

export const ClosingTop = styled.div`
  align-items: center;
  display: flex;
  gap: 70px;
  justify-content: space-between;
  padding-bottom: 68px;

  @media ${deviceMax.tabletWideMax} {
    gap: 35px;
  }

  @media ${deviceMax.phoneMax} {
    display: block;
    padding-bottom: 43px;
  }
`;

export const ClosingTitle = styled.h2`
  ${withDisplayHeading("48px")};
  max-width: 570px;

  @media ${deviceMax.desktopSMax} {
    font-size: 43px;
  }

  @media ${deviceMax.tabletWideMax} {
    font-size: 38px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 37px;
  }
`;

export const ClosingDescription = styled.p`
  color: #d0dcea;
  font-size: 15px;
  margin: 20px 0 0;
  max-width: 540px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 13px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
    line-height: 1.8;
  }
`;

export const FooterBottom = styled.footer(
  ({ theme }) => css`
    align-items: center;
    border-top: 1px solid ${theme.colors.brand.onDark.line};
    display: flex;
    gap: 34px;
    justify-content: space-between;
    padding: 28px 0;

    @media ${deviceMax.phoneMax} {
      flex-wrap: wrap;
      gap: 22px;
      padding: 25px 0;
    }
  `
);

export const FooterBrandLink = styled(Link)`
  text-decoration: none;

  figcaption {
    font-size: 8px;
  }
`;

export const FooterCompany = styled.p`
  color: #aebed0;
  font-size: 10px;
  line-height: 1.8;
  margin: 0 auto 0 0;

  span {
    display: block;
  }

  @media ${deviceMax.phoneMax} {
    margin: 0;
  }
`;

export const FooterLinks = styled.nav`
  align-items: center;
  color: #d1dbe7;
  display: flex;
  font-size: 11px;
  gap: 23px;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.white};
      text-decoration: underline;
    }
  }

  @media ${deviceMax.tabletWideMax} {
    gap: 17px;
  }

  @media ${deviceMax.phoneMax} {
    flex-basis: 100%;
    flex-wrap: wrap;
    gap: 23px;
  }
`;
